module.exports = __webpack_public_path__ + "static/media/x-button-grey.b34b40ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/x-button-grey.svg
// module id = 814
// module chunks = 0